import { Center, Dialog, Flex, Image, Stack, Text } from '@chakra-ui/react';
import { CloseIcon, SafeDeleteIcon, SafeMessageIcon, SafeReportIcon } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';
import SafeIcon from './images/safe.png';

export function SafetyToolsDialog({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}) {
  const { t } = useTranslation();
  const list = [
    {
      title: t('general.safetyToolsTitle1'),
      description: (
        <MyTrans
          i18nKey="general.safetyToolsDescription1"
          components={{
            component: <Text as="span" color="brand" cursor="pointer"></Text>,
          }}
        />
      ),
      icon: <SafeDeleteIcon />,
    },
    {
      title: t('general.safetyToolsTitle2'),
      description: t('general.safetyToolsDescription2'),
      icon: <SafeMessageIcon />,
    },
    {
      title: t('general.safetyToolsTitle3'),
      description: t('general.safetyToolsDescription3'),
      icon: <SafeReportIcon />,
    },
  ];
  return (
    <Dialog.Root
      placement="center"
      open={isOpen}
      onOpenChange={(details) => setIsOpen(details.open)}
      unmountOnExit
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content bg="bg.subtle">
          <Dialog.Header justifyContent="flex-end" pb="0" pt="3">
            <Center cursor="pointer" onClick={() => setIsOpen(false)}>
              <CloseIcon />
            </Center>
          </Dialog.Header>
          <Dialog.Body px="5" py="0" pb="5">
            <Stack direction="column" alignItems="center" justifyContent="center">
              <Image src={SafeIcon} width="112px" height="112px" alt="safe" />
              <Flex direction="column" align="center" gap="4" mt="4">
                <Text fontSize="2xl" fontWeight="semibold">
                  <MyTrans i18nKey="general.safetyToolsTitle" />
                </Text>
                <Text fontSize="sm" fontWeight="semibold">
                  <MyTrans i18nKey="general.safetyToolsDescription" />
                </Text>
              </Flex>
              <Stack mt="8" w="full" gap="2.5">
                {list.map((item) => (
                  <Flex key={item.title} align="flex-start" gap="2" bg="bg" rounded="xl" p="4">
                    {item.icon}
                    <Stack gap="1" lineHeight="normal">
                      <Text fontSize="sm" fontWeight="semibold">
                        {item.title}
                      </Text>
                      <Text fontSize="xs" fontWeight="semibold" color="fg.muted">
                        {item.description}
                      </Text>
                    </Stack>
                  </Flex>
                ))}
              </Stack>
              <Text
                mt="4"
                fontSize="sm"
                fontWeight="medium"
                color="brand"
                lineHeight="normal"
                textDecoration="underline"
                cursor="pointer"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                <MyTrans i18nKey="general.safetyToolsLearnMore" />
              </Text>
            </Stack>
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
